export enum DataCollectionStep {
  Loading = 'Loading',
  AimingShots = 'AimingShots',
  AnalysisShots = 'AnalysisShots',
  PitchComplete = 'PitchComplete',
}

export type DataCollectionMode = 'BTC' | 'RT' | 'HWD';
